import CustomTabs from '@/components/CustomTabs';
import Section from '@/components/Section';
import { Typography } from '@mui/material';
import { useState } from 'react';
import { options } from './mockData';
import CustomTabPanel from '@/components/CustomTabPanel';
import DataSyncTabContent from './components/DataSyncTabContent';

const FeaturedIntegrationsSection = () => {
  const [currentTab, setCurrentTab] = useState<number>(0);
  return (
    <Section pb={0} pt={{ xs: 0, md: 17.5 }}>
      <Typography variant='h2'
        sx={{
          marginBottom: { xs: '22px', md: '49px' },
          textAlign: 'center'
        }}
      >
        Featured Integrations
      </Typography>
      <CustomTabs
        onChange={setCurrentTab}
        value={currentTab}
        type='textWithIcon'
        options={options.map(({ label, icon: Icon }) => ({
          label,
          icon: <Icon />
        }))}
        wrapperSx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
        tabsSx={{
          width: { xs: '100%', md: 'fit-content' },
        }}
      >
        <CustomTabPanel 
          value={currentTab} 
          index={0} 
          sx={{ paddingTop: { xs: '24px', md: '68px' } }}
        >
          <DataSyncTabContent />
        </CustomTabPanel>
      </CustomTabs>
    </Section>
  );
};

export default FeaturedIntegrationsSection;